import React from "react";

import { minimumResponses } from "src/utils/minimum_thresholds";

import { ProgressCircle } from "./progress_circle";

/*
 * Types
 */

export interface ProgressCircleGroupProps {
    /*
     * Probably should just pass in report and destructure but since Parse can only type this
     * as an Object we need a way to provide more safety hence the custom typing below
     *
     * Hans H. 6 May 2020
     */
    readonly constituentGroups: Record<ConstituencyGroup, number>;
    readonly submissionProgress: Record<ConstituencyGroup, number>;
    readonly surveysCompleted: Record<ConstituencyGroup, number>;
}

/*
 * Main
 */

export const ProgressCircleGroup = (props: ProgressCircleGroupProps): React.ReactElement => {
    const { constituentGroups, surveysCompleted } = props;

    return (
        <>
            <ProgressCircle
                data-testid="progress-circle-students"
                totalCompleted={surveysCompleted.students}
                totalRequired={minimumResponses("students", constituentGroups.students)}
            >
                Students
            </ProgressCircle>
            <ProgressCircle
                data-testid="progress-circle-teachers"
                totalCompleted={surveysCompleted.teachers}
                totalRequired={minimumResponses("teachers", constituentGroups.teachers)}
            >
                Teachers
            </ProgressCircle>
            <ProgressCircle
                data-testid="progress-circle-administrators"
                totalCompleted={surveysCompleted.administrators}
                totalRequired={minimumResponses("administrators", constituentGroups.administrators)}
            >
                Administrators
            </ProgressCircle>
            <ProgressCircle
                data-testid="progress-circle-supportStaff"
                totalCompleted={surveysCompleted.supportStaff}
                totalRequired={minimumResponses("supportStaff", constituentGroups.supportStaff)}
            >
                Support Staff
            </ProgressCircle>
            <ProgressCircle
                data-testid="progress-circle-parents"
                totalCompleted={surveysCompleted.parents}
                totalRequired={minimumResponses("parents", constituentGroups.parents)}
            >
                Parents
            </ProgressCircle>
            <ProgressCircle
                data-testid="progress-circle-alumni"
                totalCompleted={surveysCompleted.alumni}
                totalRequired={minimumResponses("alumni", constituentGroups.alumni)}
            >
                Alumni
            </ProgressCircle>
            <ProgressCircle
                data-testid="progress-circle-boardMembers"
                totalCompleted={surveysCompleted.boardMembers}
                totalRequired={minimumResponses("boardMembers", constituentGroups.boardMembers)}
            >
                Board Members
            </ProgressCircle>
        </>
    );
};
